
/* injects from baggage-loader */

'use strict';

import { bottomRightBallonPosition } from '_appRoot/index.const';

export default class AbeldoChromaDialogController {
    constructor($log, $scope, $rootScope, $element, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$timeout = $timeout;
        
        this.currentScene = null;

        this.ballonPosition = bottomRightBallonPosition;
    }    

    $onInit(){
        this.$timeout(()=>{
            this.currentScene = 0;
            this.scenes[this.currentScene].visible = true
        }, 1000);
    }

    onCloseBallon(){
        if(this.currentScene < ( this.scenes.length - 1 ) ){
            this.scenes[this.currentScene].visible = false;
            this.currentScene++;
            this.scenes[this.currentScene].visible = true;
        } else{
            this.scenes[this.currentScene].visible = false;
            this.onFinish();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/abeldo-chroma-dialog-scene/abeldo-chroma-dialog-scene.controller.js